/**
 * Perfis que já entraram neste computador (posto compartilhado da fábrica).
 *
 * Guarda SÓ e-mail e nome para o operador tocar no próprio perfil e digitar a
 * senha. Nunca senha, token ou sessão: cada entrada passa pela autenticação normal.
 */
export type RecentProfile = { email: string; full_name: string };

const KEY = 'mestti-recent-profiles';
const MAX = 8;

export const readRecentProfiles = (): RecentProfile[] => {
  try {
    const parsed = JSON.parse(localStorage.getItem(KEY) || '[]');
    return Array.isArray(parsed)
      ? parsed.filter((p) => typeof p?.email === 'string' && p.email).slice(0, MAX)
      : [];
  } catch {
    return [];
  }
};

const write = (profiles: RecentProfile[]) => {
  try {
    localStorage.setItem(KEY, JSON.stringify(profiles.slice(0, MAX)));
  } catch {
    /* Storage indisponível: o login segue funcionando sem a lista. */
  }
};

export const rememberProfile = ({ email, full_name }: RecentProfile) => {
  const key = email.trim().toLowerCase();
  write([
    { email: key, full_name: full_name || key },
    ...readRecentProfiles().filter((p) => p.email.toLowerCase() !== key),
  ]);
};

export const forgetProfile = (email: string) =>
  write(readRecentProfiles().filter((p) => p.email.toLowerCase() !== email.toLowerCase()));
